<script>
    export default {
        
    }
</script>

<template>
    <div class="image-link is-relative skeleton">
        <div class="image-link-image image-link-image-skeleton image"></div>
        <div class="image-link-content">
            <h3 class="title"><progress class="progress is-large" max="100"></progress></h3>
            <h4 class="title"><progress class="progress is-small" max="100"></progress></h4>
        </div>
    </div>
</template>
